/**
 * @lodex-pro/web-portal/hooks/useDisposalMagicLinkIssueMutation — TanStack Query
 * mutation hook wrapping publicApi.disposalMagicLinkIssue (DEC-160).
 *
 * Mirrors useMagicLinkIssueMutation. Uses bare `useMutation` — no auth headers.
 * Response is void (202 empty body).
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { disposalMagicLinkIssue, type PublicApiError } from '../public/publicApi';
import type { DisposalMagicLinkIssueRequest } from '@lodex-pro/shared/validation/disposal-portal';

export function useDisposalMagicLinkIssueMutation(): UseMutationResult<
  void,
  PublicApiError,
  DisposalMagicLinkIssueRequest
> {
  return useMutation<void, PublicApiError, DisposalMagicLinkIssueRequest>({
    mutationFn: (body) => disposalMagicLinkIssue(body),
  });
}
